/**
 * Ekya — local wishlist (localStorage) + header button
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('ekya-premium')) return;

  const STORAGE_KEY = 'ekya-wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function write(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('ekya:wishlist-updated', { detail: { ids } }));
  }

  function toggle(id) {
    const ids = read();
    const i = ids.indexOf(id);
    if (i === -1) ids.push(id);
    else ids.splice(i, 1);
    write(ids);
    return ids.includes(id);
  }

  function count() {
    return read().length;
  }

  function updateBadge(btn) {
    const badge = btn.querySelector('.ekya-wishlist__count');
    const n = count();
    if (badge) badge.textContent = n > 0 ? String(n) : '';
    btn.classList.toggle('ekya-wishlist--has-items', n > 0);
  }

  function injectHeaderButton() {
    const actions = document.querySelector('header-actions .header-actions__actions, header-actions .header__column--right, header-actions');
    if (!actions || document.querySelector('.ekya-wishlist-btn')) return;

    const btn = document.createElement('a');
    btn.href = '/pages/wishlist';
    btn.className = 'header-actions__action ekya-wishlist-btn';
    btn.setAttribute('aria-label', 'Wishlist');
    btn.innerHTML =
      '<span class="svg-wrapper" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 21s-8-4.5-8-11a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6.5-8 11-8 11z"/></svg></span><span class="ekya-wishlist__count" aria-hidden="true"></span>';

    const searchBtn = actions.querySelector('[data-testid="search-action"], .header-actions__search, search-button, [aria-label*="Search"]');
    if (searchBtn && searchBtn.parentElement) {
      searchBtn.parentElement.insertBefore(btn, searchBtn.nextSibling);
    } else {
      actions.appendChild(btn);
    }
    updateBadge(btn);
    document.addEventListener('ekya:wishlist-updated', () => updateBadge(btn));
  }

  function bindCardButtons() {
    document.querySelectorAll('product-card[data-product-id]').forEach((card) => {
      const id = card.dataset.productId;
      if (!id || card.querySelector('.ekya-wishlist-card-btn')) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ekya-wishlist-card-btn';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 21s-8-4.5-8-11a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 6.5-8 11-8 11z"/></svg>';

      const sync = () => btn.classList.toggle('is-active', read().includes(id));
      sync();

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(id);
        sync();
      });

      const gallery = card.querySelector('.card-gallery, .product-card__content');
      if (gallery) gallery.appendChild(btn);
    });
  }

  window.EkyaWishlist = { read, toggle, count };

  function init() {
    injectHeaderButton();
    bindCardButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
